import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Facility } from 'src/app/services/firebase-utilities.service';
import { SharingPatientId } from '../../sharing-setup/sharing-setup.component';

@Component({
  selector: 'app-facility-list',
  templateUrl: './facility-list.component.html',
  styleUrls: ['./facility-list.component.scss'],
  standalone: false
})
export class FacilityListComponent {
  @Input() facilities: Facility[] = [];
  @Input() selectedFacility: SharingPatientId | null = null;

  @Output() facilityClick = new EventEmitter<Facility>();

  get filteredFacilities(): Facility[] {
    return this.facilities.filter(f => f.planCode === 'hub' || f.planCode === 'spoke');
  }

  getFacilityDisplayName(facility: Facility): string {
    return facility?.aet || facility?.name || facility?.id || 'Facility';
  }

  getFacilityRole(facility: Facility): 'hub' | 'spoke' | null {
    if (!facility.planCode) return null;
    return facility.planCode === 'spoke' ? 'spoke' : 'hub';
  }

  isFacilitySelected(facility: Facility): boolean {
    return !!(facility?.id && this.selectedFacility?.facility === facility.id);
  }

  onFacilityClick(facility: Facility): void {
    this.facilityClick.emit(facility);
  }
}
